module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Suits_S8.a4cebd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Suits_S8.jpg
// module id = X/db
// module chunks = 0